import PropTypes from 'prop-types';
import React from 'react';

import { Tooltip } from 'common-src/components/base';
import { getCurrentUserId } from 'common-src/features/auth';
import { singleModelSelector } from 'common-src/utils/selectorUtils';

import useCustomSelector from 'src/hooks/useCustomSelector';

import styles from './CareOrchestrationHeader.module.scss';

const CareOrchestrationHeader = ({
  view,
  readinessStats,
  stats,
  tabAvailability,
  onChangeView,
  onClearSelections,
}) => {
  const safeReadiness = readinessStats ?? { red: 0 };
  const safeStats = stats ?? { total: 0 };
  const safeTabAvailability = tabAvailability ?? {};
  const currentUser = useCustomSelector((state) =>
    singleModelSelector(state, 'Client', getCurrentUserId(state)),
  );
  const today = new Date().toISOString().slice(0, 10);
  const userInitials = `${currentUser?.firstName?.charAt(0) || ''}${
    currentUser?.lastName?.charAt(0) || ''
  }`;

  const tabs = [
    {
      key: 'readiness',
      label: 'Readiness',
      badge: safeReadiness.red > 0 ? `${safeReadiness.red} not ready` : null,
      disabled: !safeTabAvailability.readiness,
      tooltipText: !safeTabAvailability.readiness ? 'Coming soon' : null,
    },
    {
      key: 'tasks',
      label: 'Tasks',
      count: safeStats.total,
      disabled: !safeTabAvailability.tasks,
      tooltipText: !safeTabAvailability.tasks ? 'Coming soon' : null,
    },
  ];

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.tabs}>
          {tabs.map((item) => {
            const tabButton = (
              <button
                key={item.key}
                type="button"
                disabled={item.disabled}
                aria-disabled={item.disabled}
                onClick={() => {
                  if (item.disabled) return;
                  onChangeView(item.key);
                  onClearSelections();
                }}
                className={`${styles.tabButton} ${view === item.key ? styles.activeTab : ''} ${
                  item.disabled ? styles.disabledTab : ''
                }`}
              >
                {item.label}
                {item.count != null && <span className={styles.tabCount}>{item.count}</span>}
                {item.badge && <span className={styles.tabBadge}>{item.badge}</span>}
              </button>
            );

            if (!item.tooltipText) return tabButton;

            return (
              <Tooltip key={item.key} title={item.tooltipText}>
                <span className={styles.tooltipWrapper}>{tabButton}</span>
              </Tooltip>
            );
          })}
        </div>
        <div className={styles.meta}>
          <span className={styles.today}>{today}</span>
          <div className={styles.avatar}>{userInitials || '--'}</div>
        </div>
      </div>
    </div>
  );
};

CareOrchestrationHeader.propTypes = {
  view: PropTypes.string,
  readinessStats: PropTypes.shape({
    red: PropTypes.number,
    yellow: PropTypes.number,
    green: PropTypes.number,
  }),
  stats: PropTypes.shape({
    total: PropTypes.number,
  }),
  tabAvailability: PropTypes.shape({
    readiness: PropTypes.bool,
    tasks: PropTypes.bool,
  }),
  onChangeView: PropTypes.func,
  onClearSelections: PropTypes.func,
};

export default CareOrchestrationHeader;
